import { useMutation } from "@apollo/client";
import { FAVORITE_OUTFIT_MUTATION } from "../graphql/mutations/outfit";
import { GET_OUTFITS_QUERY } from "../graphql/queries";

export const useFavoriteOutfit = () => {
  const [favoriteOutfitMutation, { loading, error }] = useMutation(
    FAVORITE_OUTFIT_MUTATION,
    {
      refetchQueries: [{ query: GET_OUTFITS_QUERY }],
      onError: (error) => {
        console.error("Error toggling favorite:", error);
      },
    }
  );

  const toggleFavorite = async (id: string) => {
    try {
      const result = await favoriteOutfitMutation({
        variables: { id },
      });
      
      if (result.data?.favoriteOutfit?.success) {
        // Success handled by refetchQueries
        return result.data.favoriteOutfit;
      } else {
        throw new Error("Failed to toggle favorite");
      }
    } catch (err) {
      console.error("Error in toggleFavorite:", err);
      throw err;
    }
  };

  return {
    toggleFavorite,
    loading,
    error,
  };
};
